export const translations = {
  en: {
    // Header
    nav: {
      services: 'Services',
      clients: 'Clients',
      contact: 'Contact',
      getStarted: 'Get Started'
    },
    // Hero
    hero: {
      badge: 'Creative Marketing Excellence',
      title1: 'WE WRITE YOUR STORY.',
      title2: 'WE GROW YOUR IMPACT.',
      companyName: 'WORLDWIDE INFLUENCE MEDIA',
      slogan: 'From local to global',
      cta: 'Enter',
      scrollText: 'Our Clients',
      stats: {
        projects: 'Projects',
        clients: 'Clients',
        years: 'Years'
      }
    },
    // Clients
    clients: {
      subtitle: 'OUR CLIENTS',
      title: 'Trusted by Leaders'
    },
    // Services
    services: {
      subtitle: 'We are not for everyone',
      title: 'OUR SERVICES',
      list: [
        {
          title: '360° SOCIAL MEDIA MARKETING',
          description: 'We orchestrate the full journey from strategy, creative direction, on-site production to seamless digital distribution turning real-world presence into measurable attention and desire.'
        },
        {
          title: 'HIGH-END VIDEO PRODUCTION',
          description: 'We craft cinematic, high-impact video content from concept to final cut, covering scripting, filming, editing and platform-ready publishing, carefully designed to capture attention and elevate your brand across social channels.'
        },
        {
          title: 'WEBSITES & DIGITAL PLATFORMS',
          description: 'We design and build modern, high-performance websites that clearly communicate credibility, authority and brand value, transforming first impressions into trust and action.'
        },
        {
          title: 'BRANDBOOKS & VISUAL IDENTITY',
          description: 'We create cohesive brand systems, from visual identity and tone of voice to clear usage guidelines, ensuring your brand remains consistent, recognizable, and desirable across every touchpoint.'
        },
        {
          title: 'INFLUENCER MARKETING',
          description: 'We partner with carefully curated creators who authentically align with your brand—amplifying relevance, reinforcing positioning, and building trust through credible influence.'
        },
        {
          title: 'MEDIA BUY & TARGETED CAMPAIGNS',
          description: 'We execute precision-targeted advertising campaigns across Meta Ads, programmatic platforms, and premium outdoor locations—maximizing reach, engagement, and conversion while optimizing every dollar spent.'
        }
      ],
      cta1: 'Millions of views generated through strategic content.',
      cta2: 'We propel brands toward excellence!'
    },
    // Contact
    contact: {
      title: "Let's Create Together",
      subtitle: 'Ready to elevate your brand? Get in touch with us.',
      formTitle: 'Get In Touch',
      formDescription: "We're here to help your brand reach new heights. Whether you're looking to amplify your social presence, create stunning content, or launch a comprehensive marketing campaign, we'd love to hear from you.",
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
      locationText: 'Global Presence',
      locationSub: 'Serving Clients Worldwide',
      form: {
        name: 'Name',
        nameRequired: 'Name *',
        namePlaceholder: 'Your name',
        email: 'Email',
        emailRequired: 'Email *',
        emailPlaceholder: 'your@email.com',
        phone: 'Phone',
        phonePlaceholder: '+1 (234) 567-890',
        message: 'Message',
        messageRequired: 'Message *',
        messagePlaceholder: 'Tell us about your project...',
        submit: 'Send Message',
        sending: 'Sending...'
      },
      toast: {
        title: 'Message Sent!',
        description: "We'll get back to you within 24 hours."
      }
    },
    // Footer
    footer: {
      description: 'From local to global. We transform brands through strategic storytelling, creative excellence, and data-driven results.',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      copyright: 'Worldwide Influence Media. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    }
  },
  ro: {
    // Header
    nav: {
      services: 'Servicii',
      clients: 'Clienți',
      contact: 'Contact',
      getStarted: 'Începe Acum'
    },
    // Hero
    hero: {
      badge: 'Excelență în Marketing Creativ',
      title1: 'SCRIEM POVESTEA TA.',
      title2: 'CREȘTEM IMPACTUL TĂU.',
      companyName: 'WORLDWIDE INFLUENCE MEDIA',
      slogan: 'De la local la global',
      cta: 'Intră',
      scrollText: 'Clienții Noștri',
      stats: {
        projects: 'Proiecte',
        clients: 'Clienți',
        years: 'Ani'
      }
    },
    // Clients
    clients: {
      subtitle: 'CLIENȚII NOȘTRI',
      title: 'Încredere din Partea Liderilor din Industrie'
    },
    // Services
    services: {
      subtitle: 'Nu suntem pentru toată lumea',
      title: 'SERVICIILE NOASTRE',
      list: [
        {
          title: 'MARKETING SOCIAL MEDIA 360°',
          description: 'Orchestrăm întreaga călătorie de la strategie, direcție creativă, producție la fața locului până la distribuție digitală perfectă, transformând prezența din lumea reală în atenție și dorință măsurabile.'
        },
        {
          title: 'PRODUCȚIE VIDEO DE ÎNALTĂ CALITATE',
          description: 'Creăm conținut video cinematic, de mare impact, de la concept până la montajul final, acoperind scrierea, filmarea, editarea și publicarea pregătită pentru platforme, conceput cu atenție pentru a capta atenția și a ridica brandul tău pe canalele sociale.'
        },
        {
          title: 'SITE-URI WEB & PLATFORME DIGITALE',
          description: 'Proiectăm și construim site-uri web moderne, de înaltă performanță, care comunică clar credibilitate, autoritate și valoarea brandului, transformând primele impresii în încredere și acțiune.'
        },
        {
          title: 'BRANDBOOK-URI & IDENTITATE VIZUALĂ',
          description: 'Creăm sisteme de brand coezive, de la identitate vizuală și tonul vocii până la ghiduri clare de utilizare, asigurându-ne că brandul tău rămâne consistent, recognoscibil și de dorit în fiecare punct de contact.'
        },
        {
          title: 'MARKETING CU INFLUENCERI',
          description: 'Colaborăm cu creatori atent selectați care se aliniază autentic cu brandul tău—amplificând relevanța, consolidând poziționarea și construind încredere prin influență credibilă.'
        },
        {
          title: 'ACHIZIȚIE MEDIA & CAMPANII ȚINTITE',
          description: 'Executăm campanii publicitare țintite cu precizie pe Meta Ads, platforme programatice și locații outdoor premium—maximizând acoperirea, implicarea și conversia, optimizând fiecare leu cheltuit.'
        }
      ],
      cta1: 'Milioane de vizualizări generate prin conținut strategic.',
      cta2: 'Propulsăm brandurile spre excelență!'
    },
    // Contact
    contact: {
      title: 'Să Creăm Împreună',
      subtitle: 'Gata să-ți ridici brandul? Ia legătura cu noi.',
      formTitle: 'Contactează-ne',
      formDescription: 'Suntem aici pentru a ajuta brandul tău să atingă noi culmi. Fie că dorești să-ți amplifici prezența socială, să creezi conținut uimitor sau să lansezi o campanie de marketing cuprinzătoare, ne-ar plăcea să auzim de la tine.',
      email: 'Email',
      phone: 'Telefon',
      location: 'Locație',
      locationText: 'Prezență Globală',
      locationSub: 'Deservim Clienți din Întreaga Lume',
      form: {
        name: 'Nume',
        nameRequired: 'Nume *',
        namePlaceholder: 'Numele tău',
        email: 'Email',
        emailRequired: 'Email *',
        emailPlaceholder: 'email@tau.com',
        phone: 'Telefon',
        phonePlaceholder: '+40 123 456 789',
        message: 'Mesaj',
        messageRequired: 'Mesaj *',
        messagePlaceholder: 'Spune-ne despre proiectul tău...',
        submit: 'Trimite Mesaj',
        sending: 'Se trimite...'
      },
      toast: {
        title: 'Mesaj Trimis!',
        description: 'Vom reveni către tine în 24 de ore.'
      }
    },
    // Footer
    footer: {
      description: 'De la local la global. Transformăm brandurile prin storytelling strategic, excelență creativă și rezultate bazate pe date.',
      quickLinks: 'Linkuri Rapide',
      followUs: 'Urmărește-ne',
      copyright: 'Worldwide Influence Media. Toate drepturile rezervate.',
      privacy: 'Politica de Confidențialitate',
      terms: 'Termeni și Condiții'
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};
